module.exports = __webpack_public_path__ + "static/media/tour-rec-yellow.356a34a6.svg";